type SeoProps = {
  title: string;
  description: string;
  keywords: string;
  path: string;
  ogType?: string;
  image?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
};

export const SITE_ORIGIN = "https://9jzs.cn";

export default function Seo({
  title,
  description,
  keywords,
  path,
  ogType = "website",
  image = "https://readdy.ai/api/search-image?query=Abstract%20editorial%20poster%20art%20with%20flowing%20warm%20coral%20and%20amber%20ribbons%20over%20a%20cream%20paper%20background%2C%20soft%20film%20grain%20texture%2C%20minimal%20modern%20magazine%20cover%20aesthetic%2C%20no%20text%2C%20no%20people&width=1200&height=630&seq=gt-og-share&orientation=landscape",
  jsonLd,
}: SeoProps) {
  const url = `${SITE_ORIGIN}${path}`;
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index,follow,max-image-preview:large" />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="瓜田观察站" />
      <meta property="og:locale" content="zh_CN" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@guatianobserver" />
      {jsonLd ? (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      ) : null}
    </>
  );
}